import React from 'react';
import { Link } from 'react-router-dom';
import OwnerPageLayout from '../components/layout/OwnerPageLayout';
import ParentLinkChild from '../components/parent/ParentLinkChild';
import { useTranslation } from 'react-i18next';

export default function ParentLinkChildPage() {
    const { t } = useTranslation(['common', 'nav']);

    return (
        <OwnerPageLayout title={t('parent.findChild')}>
            <ParentLinkChild />
            <p style={{ textAlign: 'center', marginTop: 24 }}>
                <Link to="/my-balance">{t('nav:myBalance', { defaultValue: 'Мой баланс' })}</Link>
            </p>
        </OwnerPageLayout>
    );
}
